import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import Tab from './Tab'
import Cd from './Cd'
import Celebration from './Celebration'
import Banner from './Banner'
import RankPart from './RankPart'
import RoomPart from './RoomPart'
import RewardPart from './RewardPart'
import Rule from './Rule'
import DropScreen from './DropScreen'
import ExtraReward from './ExtraReward'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.nationStore = this.props.store.register('activity/nationalTemplate')
    setDocumentTitle('National Day')
  }

  state = {
    lang: langM.ar,
    mainTabState: 1,
    secondTabState: 2,
    isShowRule: false,
    WorldMyRank: {},
    worldRankList: [],
    nationMyRank: {},
    nationRankList: [],
    myRoom: {},
    roomList: [],
    cd: 0,
    language:'en',
    config: {},
    giftList: [],
    reward: {},

    isInit: true
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })

    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid
    })

    try {
      // 根据不同国家id适配
      let { nId=18 } = this.props.location.query
      // 获取配置
      let config = await this.nationStore.getConfig({ nationalDayId: parseInt(nId) })
      let cd = await this.nationStore.getCd({ nationalDayId: parseInt(nId) })
      let gift = await this.nationStore.getGiftList({ nationalDayId: parseInt(nId), type: 2 })
      let world = await this.nationStore.getUserList({ nationalDayId: parseInt(nId), type: 2 })
      let nation = await this.nationStore.getUserList({ nationalDayId: parseInt(nId), type: 1 })
      let room = await this.nationStore.getRoomList({ nationalDayId: parseInt(nId), type: 2 })
      let reward = await this.nationStore.getReward({ nationalDayId: parseInt(nId) })

      // 测试数据
      // let world = await this.nationStore.getUserList({ nationalDayId: 16, type: 2 })
      // let nation = await this.nationStore.getUserList({ nationalDayId: 16, type: 1 })
      // let room = await this.nationStore.getRoomList({ nationalDayId: 16, type: 2 })
      // let reward = await this.nationStore.getReward({ nationalDayId: 16 })
      
      this.setState({
        config: config,
        isInit: false,
        cd: cd,
        giftList: gift,
        WorldMyRank: world && world.myrank,
        worldRankList: world && world.list,
        nationMyRank: nation && nation.myrank,
        nationRankList: nation && nation.list,
        myRoom: room && room.myrank,
        roomList: room && room.list,
        reward: reward
      })
    } catch (error) {
      console.log(error)
    } finally {
    }
  }

  componentDidMount() {}

  // 改变副tab栏
  onChangeSecondState = (state) => {
    this.setState({
      secondTabState: state
    })
  }
  // 改变主tab栏
  onChangeMainState = (state) => {
    this.setState({
      mainTabState: state,
      secondTabState: 2
    })
  }
  // 关闭规则
  onChangeRule = (state) => {
    this.setState({
      isShowRule: state
    })
  }

  ruleComp(config) {
    return (
      <Rule
        // 规则显隐
        isShowRule={this.state.isShowRule}
        // 改变显隐状态
        onChangeRule={(v) => {
          this.onChangeRule(v)
        }}
        // 规则标题背景
        titleBg={config.contentTitleBg}
        // 框 - 头部
        topBg={config.topBg}
        // 框 - 主体
        centerBg={config.centerBg}
        // 框 - 底部
        bottomBg={config.bottomBg}
        // 规则标题
        ruleTitle={this.state.lang.rule}
        // 规则内容
        ruleContent={config}
        // 语言
        language={this.state.language}
      />
    )
  }

  rewardComp(config) {
    return (
      <RewardPart
        // 框 - 头部
        topBg={config.topBg}
        // 框 - 主体
        centerBg={config.centerBg}
        // 框 - 底部
        bottomBg={config.bottomBg}
        // 奖励显隐
        isShow={this.state.mainTabState == 3}
        // 奖励列表
        rewardList={
          this.state.mainTabState == 3 && this.state.secondTabState == 1
            ? this.state.reward.world
            : this.state.reward.country
        }
        // 房间奖励
        roomRewardList={this.state.reward.room}
      />
    )
  }

  roomComp(config) {
    return (
      <RoomPart
        // 房间显隐
        isShow={this.state.mainTabState == 2}
        // 房间我的排行
        myRoom={this.state.myRoom}
        // 房间排行
        roomList={this.state.roomList}
        // 第一二三名头像框
        headWear1={config.rankTop1}
        headWear2={config.rankTop2}
        headWear3={config.rankTop3}
        // 房间背景
        bigBg={config.rankRoomBg}
        bgColor1={config.bgColor}
        bgColor2={config.bgColor2}
      />
    )
  }

  rankComp(config) {
    return (
      <RankPart
        // 排行显隐
        isShow={this.state.mainTabState == 1}
        // 排行列表
        rankList={
          this.state.mainTabState == 1 && this.state.secondTabState == 1
            ? this.state.worldRankList
            : this.state.nationRankList
        }
        // 我的排行
        myRank={
          this.state.mainTabState == 1 && this.state.secondTabState == 1
            ? this.state.WorldMyRank
            : this.state.nationMyRank
        }
        // 第一名头像框
        headWear1={config.rankTop1}
        // 第二名头像框
        headWear2={config.rankTop2}
        // 第三名头像框
        headWear3={config.rankTop3}
        // 排行背景
        bigBg={config.rankRoomBg}
        bgColor1={config.bgColor}
        bgColor2={config.bgColor2}
      />
    )
  }

  tabComp(config) {
    return (
      <Tab
        // 激活背景
        activeBg={config.tabActiveBg}
        // 未激活背景
        inActiveBg={config.tabInactiveBg}
        // 底部大背景
        tabBg={config.tabBigBg1}
        // 语言
        lang={this.state.lang}
        // 主 tab 按钮状态
        mainTabState={this.state.mainTabState}
        // 副 tab 按钮状态
        secondTabState={this.state.secondTabState}
        // 改变主按钮状态
        onChangeMainState={(v) => {
          this.onChangeMainState(v)
        }}
        // 改变副按钮状态
        onChangeSecondState={(v) => {
          this.onChangeSecondState(v)
        }}
        // 副按钮是否显示
        secondIsShow={this.state.mainTabState != 2}
      />
    )
  }

  celeComp(config) {
    return (
      <Celebration
        // 标题背景
        titleBg={config.contentTitleBg}
        // 框 - 头部
        topBg={config.topBg}
        // 框 - 主体
        centerBg={config.centerBg}
        // 框 - 底部
        bottomBg={config.bottomBg}
        // 礼物列表
        giftList={this.state.giftList}
        config={config}
        language={this.state.language}
      />
    )
  }

  extraReward(config) {
    return (
      <ExtraReward
        // 标题背景
        titleBg={config.contentTitleBg}
        // 框 - 头部
        topBg={config.topBg}
        // 框 - 主体
        centerBg={config.centerBg}
        // 框 - 底部
        bottomBg={config.bottomBg}
        bgColor1={config.bgColor}
        bgColor2={config.bgColor2}
        extraRewardImage={config.extraRewardImage}
        extraRewardName={config.extraRewardName}
        extraRewardDay={config.extraRewardDay}
        extraRewardProgress={config.extraRewardProgress}
        exRw={this.state.lang.exRw}
        extraRewardProgressVal={config.extraRewardProgressVal}
      />
    )
  }

  bannerComp(config) {
    return (
      <Banner
        // banner 背景
        banner={config.bannerBg}
        // banner 第一名头像框
        headWear={config.bannerTopHead}
        // 规则按钮背景
        ruleBg={config.bannerRuleBg}
        // 第一名对象（头像显示）
        top={this.state.worldRankList && this.state.worldRankList[0]}
        // 语言
        lang={this.state.lang}
        // 规则显隐按钮
        onChangeRule={(v) => {
          this.onChangeRule(v)
        }}
      />
    )
  }

  render() {
    const { config } = this.state
    return (
      <div className="nation-template-main-box">
        {/* 外部大背景 */}
        <div className="outerBg" style={{ backgroundImage: `url(${config.tabBigBg2})` }}></div>

        {/* 主体内容 */}
        <div className={`national-template-wrap ${this.state.language == 'ar' ? 'arlang' : ''}`}>
          {/* 雨 */}
          <DropScreen image={config.tabBigBg3} />

          {/* 初始化白页面 */}
          <div className="mask-main" style={{ display: `${this.state.isInit ? 'block' : 'none'}` }}></div>

          {/* 横幅 */}
          {this.bannerComp(config)}

          {/* 倒计时 */}
          <Cd remaintime={this.state.cd} />

          {/* 内容 */}
          {this.celeComp(config)}

          {/* 额外奖励 */}
          {config && config.extraRewardName && this.extraReward(config)}

          {/* 选项卡 */}
          {this.tabComp(config)}

          {/* 用户排行 */}
          {this.rankComp(config)}

          {/* 房间排行 */}
          {this.roomComp(config)}

          {/* 奖励 */}
          {this.rewardComp(config)}

          {/* 规则 */}
          {this.ruleComp(config)}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/index.js